import { type ReactNode, useEffect, useState } from 'react';
import { LoadingImage } from '@/components/Loading';
import { cn } from '@/utils/tailwind.util';
export const DelayedLoadingFallback = ({
  delayMS,
  children,
  subText,
  className
}: {
  /** delayMS 후 로딩 화면이 보여집니다 */
  delayMS: number;
  /** 지정 시 기본 LoadingImage 대신 렌더링됩니다 */
  children?: ReactNode;
  subText?: string;
  className?: string;
}) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delayMS);
    return () => clearTimeout(timer);
  }, [delayMS]);
  if (!isVisible) return null;
  if (children) return <>{children}</>;
  return <div className={cn('flex flex-col items-center justify-center gap-xs', className)} data-sentry-component="DelayedLoadingFallback" data-sentry-source-file="DelayedLoadingFallback.tsx">
      <LoadingImage data-sentry-element="LoadingImage" data-sentry-source-file="DelayedLoadingFallback.tsx" />
      {subText && <span className="text-body-md-bold text-alternative">{subText}</span>}
    </div>;
};